import { IComponentOptions } from "angular";
import { ChangeJournalViewComponentItemController } from "../../../../../../records/changeJournal/changeJournalViewComponent/itemObjectDetail/componentController";

export const vsComponentName = "changeJournalMasterAgreementAmendmentComponent";
export const changeJournalMasterAgreementAmendmentComponentOptions: IComponentOptions =
  {
    template: require("!html-loader!./index.html").default,
    controllerAs: "itemController",
    controller: ChangeJournalViewComponentItemController,
    bindings: {
      logItem: "<",
    },
  };
